import Vue from 'vue'
import App from './App.vue'
import router from './router'
import api from "./utils/request";
import utils from "../utils/utils";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import i18n from "../lang/i18n";

Vue.config.productionTip = false
Vue.prototype.$api = api;
Vue.prototype.$utils = utils;

Vue.use(ElementUI, {i18n: (key, value) => i18n.t(key, value)});

new Vue({
    router,
    i18n,
    render: h => h(App)
}).$mount('#app')
